<ng-container *ngIf="match.sides[sideNumber - 1]?.players">
    <ng-template ngFor let-player let-i="index" [ngForOf]="match.sides[sideNumber - 1].players">
        <br *ngIf="i === 1" />
        <ion-text class="text" [style.color]="getColor(i + 1)">
            {{ getParticipantName(player.participant) }}
            <span [class]="{ 'team-name': !isStreamView, 'stream-team-name': isStreamView }" *ngIf="tie">({{ getTeamName() }})</span>
        </ion-text>
    </ng-template>
</ng-container>